<template>
    <div class="form-wrapper">
        <h1>{{ mode === 'email' ? 'Change Email' : 'Change Password' }}</h1>
        <p>{{ mode === 'email' ? 'Update the email address for ' + guest.name + '.' : 'Set a new password for ' + guest.name + '.' }}</p>

        <div class="alert alert-danger p-0" v-if="error">{{ error }}</div>
        <div class="alert alert-success p-0" v-if="success">{{ success }}</div>

        <form action="#" class="new-project-form" @submit.prevent="save" v-if="!success">
            <div class="form-group" v-if="mode === 'email'">
                <label>New Email</label>
                <input type="email" class="form-control" placeholder="New email address" v-model="email">
            </div>
            <div class="form-group" v-if="mode === 'password'">
                <label>New Password</label>
                <div class="password-field">
                    <input type="text" class="form-control" v-model="password">
                    <button type="button" class="btn btn-outline-dark btn-sm btn-regenerate" @click.prevent="generatePassword">Regenerate</button>
                </div>
            </div>
            <div class="">
                <button type="submit" class="btn btn-primary" style="width: 180px" :disabled="saving">
                    <span class="spinner-border" v-if="saving"></span>
                    <span :class="{'opacity-0': saving}">Save</span>
                </button>
            </div>
        </form>

        <button type="button" class="btn btn-outline-dark w-100 mt-2" v-if="success" @click.prevent="done">Done</button>
    </div>
</template>

<script>
import repository from "@/repository/repository";

export default {
    name: "EditGuestPopup",
    props: ['mode', 'guest'],
    data() {
        return {
            email: "",
            password: "",
            error: null,
            success: null,
            saving: false,
        }
    },
    methods: {
        generatePassword() {
            var chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
            var result = '';
            for (var i = 0; i < 12; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            this.password = result;
        },
        save() {
            this.saving = true;
            this.error = null;

            if (this.mode === 'email') {
                if (!this.email || !this.email.includes("@")) {
                    this.error = "A valid email address is required.";
                    this.saving = false;
                    return;
                }
                repository.put("/guests/" + this.guest.id + "/email", {
                    email: this.email,
                })
                    .then(function () {
                        this.saving = false;
                        this.success = "Email has been updated successfully.";
                        this.$root.$emit('reloadGuests');
                    }.bind(this))
                    .catch(function (error) {
                        this.error = (error.response && error.response.data && error.response.data.message) || "An error occurred.";
                        this.saving = false;
                    }.bind(this));
            } else {
                if (!this.password || this.password.length < 8) {
                    this.error = "Password must be at least 8 characters.";
                    this.saving = false;
                    return;
                }
                repository.put("/guests/" + this.guest.id + "/password", {
                    password: this.password,
                })
                    .then(function () {
                        this.saving = false;
                        this.success = "Password has been updated successfully.";
                        this.$root.$emit('reloadGuests');
                    }.bind(this))
                    .catch(function (error) {
                        this.error = (error.response && error.response.data && error.response.data.message) || "An error occurred.";
                        this.saving = false;
                    }.bind(this));
            }
        },
        done() {
            this.$root.$emit('closePopups');
        },
        reset() {
            this.email = "";
            this.password = "";
            this.error = null;
            this.success = null;
            this.saving = false;
            this.generatePassword();
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.form-wrapper {
    h1 {
        font-size: 1.25rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
    }

    p {
        color: $grey-text;
        margin-bottom: 1.5rem;
    }
}

.password-field {
    position: relative;

    .form-control {
        padding-right: 120px !important;
        font-family: monospace;
        letter-spacing: 0.5px;
    }

    .btn-regenerate {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
    }
}
</style>
